import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import AddSellerIndividualForm from './AddSellerIndividualForm';

const ScheduleSeller = (props) => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<AddSellerIndividualForm 
			SchoolStorageID={schoolID}
			{...props}
		/>

	);
};

export default ScheduleSeller;
